import React from "react";
import FlyingCurrency from "./FlyingCurrency";

interface FlyingCoinsProps {
  isAnimating: boolean;
}

export default function FlyingCoins({ isAnimating }: FlyingCoinsProps) {
  return <FlyingCurrency variant="coin" isAnimating={isAnimating} />;
}
